export default {
    data() {
        return {
            isBusy: null
        }
    },
    methods: {
        makePost(url, params, successCallback, failCallback, showBusyIndicator = true){
            this.isBusy = showBusyIndicator;
            this.hideStatusMessages();
            return axios.post(url, params)
                .then(response => {
                    if(successCallback) {
                        successCallback(response.data);
                    }
                })
                .catch(() => {
                    if(!failCallback){
                        this.showCommunicationFailed();
                    }
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        makeGet(url, params, successCallback, failCallback, showBusyIndicator = true){
            this.isBusy = showBusyIndicator;
            this.hideStatusMessages();
            return axios.get(url, {params: params})
                .then(response => {
                    if(successCallback) {
                        successCallback(response.data);
                    }
                })
                .catch(() => {
                    if(!failCallback){
                        this.showCommunicationFailed();
                    }
                })
                .finally(() => {
                    this.isBusy = false;
                });
        }

    },
}